export enum OKRCategories {
    None = '', // Empty Category is used when scenario action does not map to a OKR category.
    Seen = 'Seen',
    Tried = 'Tried',
    TriedResponse = 'Tried_Response',
    Kept = 'Kept',
    ThumbsUp = 'ThumbsUp',
    ThumbsDown = 'ThumbsDown',
}
